/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { push } from '@lagunovsky/redux-react-router';
import * as React from 'react';
import { Route, Routes } from 'react-router';
import Footer from '../../components/Footer';
import { ActionForwardComponent } from '../../components/Highscores';
import { CacheStatisticsScreen } from '../../components/SysAdminApp/CacheStatisticsComponent';
import { ClientPropertyComponent } from '../../components/SysAdminApp/ClientPropertyComponent';
import { EventHandlerConfigScreen } from '../../components/SysAdminApp/EventHandlerConfig';
import { MailoutComp } from '../../components/SysAdminApp/MailoutComponent';
import { SqlStatisticsScreen } from '../../components/SysAdminApp/SQLStatisticsComponent';
import { sysAdminJobPath, sysAdminSqlPath, sysAdminUseCaseLogPath } from '../../components/SysAdminApp/sysAdminPathes';
import { SysAdminSportsApp } from '../../components/SysAdminApp/SysAdminSportsApp';
import { UpdateTasksScreen } from '../../components/SysAdminApp/UpdateTaskComp';
import { UseCaseLogScreen } from '../../components/SysAdminApp/UseCaseLogs';
import { UserAdminApp } from '../../components/SysAdminApp/UserAdminSearch';
import { WebUsageScreen } from '../../components/SysAdminApp/WebUsage';
import { JobScreen } from './JobScreen';
import { SystemProperties } from './SystemProperties';
import { TranslationScreen } from '../../components/SysAdminApp/TranslationComp';
import { ClientStatsScreen } from '../../components/SysAdminApp/ClientStatsComp';
import {DbChangesComp} from "../../components/SysAdminApp/DBChangesComp/dbChangesComp";

export const SysAdmin: React.FC<{}> = () => {
    return (
        <>
            <Routes>
                <Route path="update-tasks" element={<UpdateTasksScreen />} />
                <Route path="translations" element={<TranslationScreen />} />
                <Route path="client-statistics" element={<ClientStatsScreen />} />
                <Route path="db-changes" element={<DbChangesComp />} />

                <Route path="mailouts" element={<MailoutComp />} />
                <Route path="jobs/:serverName" element={<JobScreen />} />
                <Route path="jobs/*" element={<ActionForwardComponent action={push(sysAdminJobPath('betting'))} />} />
                <Route path="sql/:serverName" element={<SqlStatisticsScreen />} />
                <Route path="sql/*" element={<ActionForwardComponent action={push(sysAdminSqlPath('betting'))} />} />
                <Route path="cache/:serverName?" element={<CacheStatisticsScreen />} />
                <Route path="usage/:serverName?" element={<WebUsageScreen />} />
                <Route path="sports/*" element={<SysAdminSportsApp />} />
                <Route path="user/*" element={<UserAdminApp />} />
                <Route path="ucl/:serverName" element={<UseCaseLogScreen />} />
                <Route
                    path="ucl/*"
                    element={<ActionForwardComponent action={push(sysAdminUseCaseLogPath('betting'))} />}
                />
                <Route path="properties" element={<SystemProperties />} />
                <Route path="client-properties" element={<ClientPropertyComponent />} />
                <Route path="event-handler/:serverName?" element={<EventHandlerConfigScreen />} />
                <Route path="/" element={<SqlStatisticsScreen />} />
            </Routes>
            <Footer />
        </>
    );
};
